import React from 'react'
import styled from '@emotion/styled'

const LoadingContainer = styled.div`
  grid-area: content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 1rem;
`

const LoadingContent = styled.div`
  text-align: center;
`

const LoadingIcon = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e9ecef;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const LoadingTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
`

const LoadingMessage = styled.p`
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0;
`

/**
 * CoachLoadingStates component - displays loading states for video/audio setup
 * Based on the candidate loading states but adapted for coach use
 *
 * @param {Object} props
 * @param {string} props.chatMode - Current chat mode (text, audio, video)
 * @param {boolean} props.hasLocalVideo - Whether local video stream is available
 * @param {boolean} props.hasRemoteVideo - Whether remote video stream is available
 * @param {boolean} props.cameraReady - Whether camera is ready for video processing
 */
const CoachLoadingStates = ({ chatMode, cameraReady }) => {
  // For video mode, show loading until camera is ready
  // For audio mode, we can show loading until we have some connection established
  if (chatMode === 'video' && cameraReady) {
    return null
  }

  const getLoadingContent = () => {
    if (chatMode === 'video') {
      return {
        title: 'Setting up video chat',
        message: 'Please wait while we establish your video connection...',
      }
    }

    if (chatMode === 'audio') {
      return {
        title: 'Setting up audio chat',
        message: 'Please wait while we establish your audio connection...',
      }
    }

    return {
      title: 'Setting up chat',
      message: 'Please wait...',
    }
  }

  const { title, message } = getLoadingContent()

  return (
    <LoadingContainer>
      <LoadingContent>
        <LoadingIcon />
        <LoadingTitle>{title}</LoadingTitle>
        <LoadingMessage>{message}</LoadingMessage>
      </LoadingContent>
    </LoadingContainer>
  )
}

export default CoachLoadingStates
